module.exports = __webpack_public_path__ + "img/bleu-6.1cd3638a.png";